interface GroupDigitsArgs {
  raw: string;
  segmentLengths: number[];
  separator: string;
}

const groupDigits = ({ raw, segmentLengths, separator }: GroupDigitsArgs) => {
  const maxDigits = segmentLengths.reduce((total, length) => total + length, 0);

  const digits = raw.replace(/\D/g, '').slice(0, maxDigits);

  const parts: string[] = [];

  let offset = 0;

  for (const length of segmentLengths) {
    if (offset >= digits.length) {
      break;
    }

    parts.push(digits.slice(offset, offset + length));

    offset += length;
  }

  return parts.join(separator);
};

interface MaskInputArgs {
  raw: string;
  isAppending: boolean;
}

export const maskDateInput = ({ raw, isAppending }: MaskInputArgs) => {
  if (isAppending && !raw.endsWith('.')) {
    return groupDigits({ raw, segmentLengths: [2, 2, 4], separator: '.' });
  }

  return raw.replace(/[^\d.]/g, '');
};

export const maskTimeInput = ({ raw, isAppending }: MaskInputArgs) => {
  if (isAppending && !raw.endsWith(':')) {
    return groupDigits({ raw, segmentLengths: [2, 2], separator: ':' });
  }

  return raw.replace(/[^\d:]/g, '');
};
